import React from "react";

import { TooltipObj } from "../../models/tooltip";

import SV from "../../styles/variables";
import styled from "styled-components";

const ToolTip: React.FunctionComponent<TooltipObj> = ({
  open,
  x = 0,
  y = 0,
  date = "Apr 10",
  views
}: TooltipObj) => {
  return (
    <HoverBox x={x} y={y} open={open}>
      <h4> {date}</h4>
      <h5>
        {views} <span> views</span>
      </h5>
    </HoverBox>
  );
};

interface ToolTipStyleProps {
  open: boolean;
  x: number;
  y: number;
}

const HoverBox = styled.div<ToolTipStyleProps>`
  background-color: ${SV.colorP5};
  border-radius: 4px;
  color: white;
  display: ${p => (p.open ? "block" : "none")};
  height: 50px;
  left: ${p => p.x}px;
  line-height: 1;
  padding: 8px;
  position: absolute;
  top: ${p => p.y}px;
  width: 100px; /* has increased slightly above spec to fit numbers up to 5 placed */
  opacity: 0.8;
  h4 {
    font-size: 12px;
    font-weight: normal;
    margin-bottom: 4px;
  }
  h5 {
    font-size: 16px;
    font-weight: 300;
    span {
      font-size: 12px;
    }
  }
` as React.FunctionComponent<ToolTipStyleProps>;

export default ToolTip;
